import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  Typography,
  Alert,
  Box,
  CircularProgress
} from '@mui/material';

const BranchSelection = ({ open, branches, user, onBranchSelect, loading }) => {
  const [selectedBranch, setSelectedBranch] = useState('');
  const [error, setError] = useState('');

  const handleBranchChange = (event) => {
    setSelectedBranch(event.target.value);
    setError('');
  };

  const handleSubmit = () => {
    if (!selectedBranch) {
      setError('Please select a branch');
      return;
    }
    
    onBranchSelect(selectedBranch);
  };

  const handleKeyPress = (event) => {
    if (event.key === 'Enter' && selectedBranch) {
      handleSubmit();
    }
  };

  return (
    <Dialog 
      open={open} 
      disableEscapeKeyDown
      disableBackdropClick
      maxWidth="sm" 
      fullWidth
    >
      <DialogTitle>
        <Typography variant="h5" component="h2">
          Select Your Branch
        </Typography>
      </DialogTitle>
      
      <DialogContent>
        <Box sx={{ mb: 3 }}>
          <Typography variant="body1" color="text.secondary" paragraph>
            Welcome back, <strong>{user?.username}</strong>!
          </Typography>
          
          <Alert severity="info" sx={{ mb: 3 }}>
            <Typography variant="body2">
              <strong>Please select your preferred branch.</strong><br />
              This will determine which branch's data you see in the Admin Dashboard. 
              This selection will be remembered for future logins, so you won't need to choose again.
            </Typography>
          </Alert>
        </Box>

        <FormControl fullWidth>
          <InputLabel id="branch-select-label">Branch</InputLabel>
          <Select
            labelId="branch-select-label"
            value={selectedBranch}
            label="Branch"
            onChange={handleBranchChange}
            onKeyPress={handleKeyPress}
            disabled={loading}
            autoFocus
          >
            {branches.map((branch) => (
              <MenuItem key={branch.name} value={branch.name}>
                {branch.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        {error && (
          <Alert severity="error" sx={{ mt: 2 }}>
            {error}
          </Alert>
        )}
      </DialogContent>
      
      <DialogActions>
        <Button 
          onClick={handleSubmit} 
          variant="contained" 
          disabled={!selectedBranch || loading}
          sx={{ minWidth: 120 }}
        >
          {loading ? (
            <CircularProgress size={20} color="inherit" />
          ) : (
            'Continue'
          )}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default BranchSelection; 